// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"803":"f9d47aa9","2454":"76434070","6977":"76434070"}[chunkId] + ".chunk.css";
};